<template>
  <div class="opreate-strategy">
    <div class="header-box">
      <div class="header-line">
        <el-button type="primary" size="small" @click="getAllStrategy">查询</el-button>
        <el-button type="primary" size="small" @click="onAddBtnClick">新增</el-button>
      </div>
    </div>
    <el-table :data="dataList" border :height="screenHeight" size="small">
      <el-table-column label="序号" width="45px">
        <template slot-scope="scope">
          {{beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="决策树名称" width="200px">
      </el-table-column>
      <el-table-column label="业务场景" width="100px">
        <template slot-scope="scope">
          <div>{{ getBusinessLabel(scope.row.businessType) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="500px">
      </el-table-column>
      <el-table-column label="状态" width="100px">
        <template slot-scope="scope">
          <!-- <el-switch v-model="scope.row.state" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch> -->
          <div>{{ scope.row.state ? "已启用" : "已停用" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editStrategy(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="detailStrategy(scope.row)">决策树</el-button>
          <el-button type="text" size="small" @click="mindDetail(scope.row)">思维导图</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick">
    </el-pagination>
    <el-dialog title="新增决策树" :visible.sync="ruleDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label">决策树名称</span>
        <el-input class="form-input" placeholder="请输入" v-model="strategyInfo.name" size="small" clearable>
        </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">业务场景</span>
        <el-radio v-model="strategyInfo.businessType" label="1">精准关键词</el-radio>
        <el-radio v-model="strategyInfo.businessType" label="2">紧密匹配</el-radio>
        <el-radio v-model="strategyInfo.businessType" label="3">广泛匹配</el-radio>
        <el-radio v-model="strategyInfo.businessType" label="4">产品价格</el-radio>
        <el-radio v-model="strategyInfo.businessType" label="5">阶段运营</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label">状态</span>
        <el-switch v-model="strategyInfo.state" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </div>
      <div class="form-line">
        <span class="form-label">备注</span>
        <el-input class="form-input" placeholder="请输入" v-model="strategyInfo.remark" size="small" clearable>
        </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ruleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  requestModules
} from '@r'
export default {
  data() {
    return {
      total: 0,
      pageCount: 1,
      screenHeight: document.body.clientHeight - 64 - 132 - 68,
      beginIndex: 0,
      ruleDialogVisible: false,
      dataList: [],
      strategyInfo: {
        name: "",
        remark: "",
        businessType: 1,
        state: true,
        rules: JSON.stringify([])
      },
      params: {
        state: null,
        beginIndex: 0,
        pageSize: 50,
      },
    }
  },
  mounted() {
    this.getAllStrategy();
    this.$eventBus.$on('resize', this.calculateHeight)
  },
  beforeDestroy() {
    this.$eventBus.$off('resize', this.calculateHeight)
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68
    },
    getAllStrategy() {
      requestModules.fetchStrategys(this.params).then(res => {
        this.dataList = res.ldata;
      })
    },
    onAddBtnClick() {
      this.strategyInfo = {
        name: "",
        remark: "",
        businessType: 1,
        state: true,
        rules: JSON.stringify([])
      }
      this.ruleDialogVisible = true;
    },
    editStrategy(row) {
      this.ruleDialogVisible = true;
      this.strategyInfo = row;
    },
    detailStrategy(row) {
      window.open("/client/opreateStrategy/detail/" + row._id)
    },
    mindDetail(row) {
      window.open("/client/opreateStrategy/mind/" + row._id)
    },
    handleConfirmBtn() {
      this.ruleDialogVisible = false;

      requestModules.addOrUpdateStrategy(this.strategyInfo).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        this.getAllStrategy();
      }).catch((err) => {
        console.log(err);
        this.getAllStrategy();
      });
    },
    getBusinessLabel(businessType) {
      let label = "";
      businessType == 1 && (label = "精准关键词");
      businessType == 2 && (label = "紧密匹配");
      businessType == 3 && (label = "广泛匹配");
      businessType == 4 && (label = "产品价格");
      businessType == 5 && (label = "阶段运营");
      return label
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAllStrategy();
    },
  }
}
</script>

<style lang="scss">
.opreate-strategy {
  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 80px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 800px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }
}
</style>
